import React from 'react';
import { ListGroup, ListGroupItem, ListGroupItemSubtitle, ListGroupItemTitle } from '@vds/lists';
import { shallowEqual, useSelector } from 'react-redux';
import { Body } from '@vds/typography';
import PropTypes from 'prop-types';
import { selectStateCache } from '../@selectors';
import { checkoutLabels } from '../Components/labels';
import { useCheckoutHooks } from '../@Redux/checkout.hooks';

const ShippingSection = (props) => {
  const stateCache = useSelector((state) => selectStateCache(state), shallowEqual);
  const { shippingAddress, storeInfo, shippingDescription, primaryUserInfo } = useCheckoutHooks(stateCache);

  const custName = primaryUserInfo?.firstName;
  const shippingType = storeInfo?.storeName ? checkoutLabels?.inStore : shippingDescription;
  const shippingAdd = storeInfo?.storeName
    ? `${storeInfo?.address1}, ${storeInfo?.city}, ${storeInfo?.zipCode}`
    : `${shippingAddress?.addressLine1}, ${shippingAddress?.city}, ${shippingAddress?.zipCode}`;

  return (
    <div>
      <ListGroup topLine={false} bottomLine surface="light" viewport="desktop">
        <ListGroupItem
          data-track='{"type":"link","name":"shipping information|express checkout","data":{"page":{"throttle":"nsa version|vhi|ec y"},"target":{"sandBox":"FWA_Express_T_Checkout"}}}'
          textHierarchy="subtitleProminent"
          actionElement="icon"
          icon={{
            onClick: () => {
              props.redirect('Shipping');
            },
          }}
        >
          <ListGroupItemTitle bold>
            {shippingType} <br />
            <Body size="large" primitive="span">
              {shippingAdd}
              {storeInfo?.storeName && (
                <>
                  <br />
                  <br />
                  <Body size="large" primitive="span">
                    {custName}
                    {checkoutLabels.gov_ID}
                  </Body>
                </>
              )}
            </Body>
          </ListGroupItemTitle>

          <ListGroupItemSubtitle>{checkoutLabels.SI}</ListGroupItemSubtitle>
        </ListGroupItem>
      </ListGroup>
    </div>
  );
};

ShippingSection.propTypes = {
  redirect: PropTypes.any,
};
export default ShippingSection;
